module.exports = __webpack_public_path__ + "fonts/NespressoLucas-SemiBdItalic.svg?v=d36a960ec7028fa287253e2e318854e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-SemiBdItalic.svg
// module id = 637
// module chunks = 0